










import { Component, Vue } from 'vue-property-decorator'

/**
 * @title 自定义前后缀
 * @desc 主要用于标识单位。
 */
@Component
export default class AppendExample extends Vue {
  value: any = null

  disabled = false
}
